if (!customElements.get('product-specs')) {
  customElements.define(
    'product-specs',
    class ProductSpecs extends HTMLElement {
      constructor() {
        super();
        const script = this.querySelector('[data-specs-by-variant]');
        this.specsByVariant = script ? JSON.parse(script.textContent) : {};
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange.bind(this));
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
      }

      onVariantChange({ data: { variant } }) {
        if (!variant) return;
        const specs = this.specsByVariant[variant.id];
        if (!specs) return;

        this.updateField('dimensions', specs.dimensions);
        this.updateField('poids', specs.poids);
      }

      updateField(field, value) {
        const dd = this.querySelector(`[data-specs-field="${field}"]`);
        const wrapper = dd ? dd.closest('div') : null;
        if (!dd || !wrapper) return;

        if (value) {
          dd.textContent = value;
          wrapper.hidden = false;
        } else {
          wrapper.hidden = true;
        }
      }
    }
  );
}
